import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSettings as getSettingsApi,
  updateSettings as updateSettingsApi,
  getRestrictedBrands as getRestrictedBrandsApi,
  getRestrictedMeltables as getRestrictedMeltablesApi,
  getRestrictedAsins as getRestrictedAsinsApi,
  updateRestrictedBrands as updateRestrictedBrandsApi,
  updateRestrictedMeltables as updateRestrictedMeltablesApi,
  updateRestrictedAsins as updateRestrictedAsinsApi,
  addRestrictedBrands as addRestrictedBrandsApi,
  addRestrictedMeltables as addRestrictedMeltablesApi,
  addRestrictedAsins as addRestrictedAsinsApi,
  deleteRestrictedBrands as deleteRestrictedBrandsApi,
  deleteRestrictedMeltables as deleteRestrictedMeltablesApi,
  deleteRestrictedAsins as deleteRestrictedAsinsApi,
  getSubscriptionFrequencies as getSubscriptionFrequenciesApi,
  updateSubscriptionFrequencyStatus as updateSubscriptionFrequencyStatusApi,
} from "../../apiCalls/caller";
import { toast } from "react-toastify";

export const getSettings = createAsyncThunk(
  "settings/getSettings",
  async () => {
    try {
      const response = getSettingsApi();
      //const data = await response;
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const updateSettings = createAsyncThunk(
  "settings/updateSettings",
  async (settings) => {
    try {
      console.log("updateSettings", settings);
      const response = updateSettingsApi(settings);
      const data = await response;
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const getRestrictedBrands = createAsyncThunk(
  "settings/getRestrictedBrands",
  async (data) => {
    try {
      const response = getRestrictedBrandsApi(data);
      //const data = await response;
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getRestrictedMeltables = createAsyncThunk(
  "settings/getRestrictedMeltables",
  async (data) => {
    try {
      const response = getRestrictedMeltablesApi(data);
      //const data = await response;
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getRestrictedAsins = createAsyncThunk(
  "settings/getRestrictedAsins",
  async (data) => {
    try {
      const response = getRestrictedAsinsApi(data);      
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const addRestrictedBrands = createAsyncThunk(
  "settings/addRestrictedBrands",
  async (brand) => {
    try {
      const response = addRestrictedBrandsApi(brand);
      //const data = await response;
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const addRestrictedMeltables = createAsyncThunk(
  "settings/addRestrictedMeltables",
  async (meltable) => {
    try {
      toast.loading("Adding restricted meltable...", {
        position: "top-center",
      });
      const response = addRestrictedMeltablesApi(meltable);
      const data = await response;

      toast.dismiss();
      if (data.success) {
        toast.success("Meltable added Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Meltable added Failed " + data.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const addRestrictedAsins = createAsyncThunk(
  "settings/addRestrictedAsins",
  async (data) => {
    try {
      const response = addRestrictedAsinsApi(data);
      //const data = await response;
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const updateRestrictedBrands = createAsyncThunk(
  "settings/updateRestrictedBrands",
  async (data) => {
    try {
      const response = updateRestrictedBrandsApi(data);
      //const data = await response;
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const updateRestrictedMeltables = createAsyncThunk(
  "settings/updateRestrictedMeltables",
  async (data) => {
    try {
      toast.dismiss();
      toast.loading("Updating status...", {
        position: "top-center",
      });
      const response = updateRestrictedMeltablesApi(data);
      const retval = await response;
      toast.dismiss();
      if (retval.success) {
        toast.success("Status updated Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Status updating Failed " + retval.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return retval;
    } catch (error) {
      return error;
    }
  }
);
export const updateRestrictedAsins = createAsyncThunk(
  "settings/updateRestrictedAsins",
  async (data) => {
    try {
      const response = updateRestrictedAsinsApi(data);
      //const data = await response;
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const deleteRestrictedBrands = createAsyncThunk(
  "settings/deleteRestrictedBrands",
  async (data) => {
    try {
      toast.dismiss();
      toast.loading("Deleting restricted brand...", {
        position: "top-center",
      });
      const response = deleteRestrictedBrandsApi(data);
      const retval = await response;
      toast.dismiss();
      if (retval.success) {
        toast.success("Item deleted Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Item deletion Failed " + retval.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const deleteRestrictedMeltables = createAsyncThunk(
  "settings/deleteRestrictedMeltables",
  async (data) => {
    try {
      toast.dismiss();
      toast.loading("Deleting restricted meltable...", {
        position: "top-center",
      });
      const response = deleteRestrictedMeltablesApi(data);
      const retval = await response;
      toast.dismiss();
      if (retval.success) {
        toast.success("Item deleted Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Item deletion Failed " + retval.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const deleteRestrictedAsins = createAsyncThunk(
  "settings/deleteRestrictedAsins",
  async (data) => {
    try {
      toast.dismiss();
      toast.loading("Deleting restricted ASIN...", {
        position: "top-center",
      });      
      const response = deleteRestrictedAsinsApi(data);
      const retval = await response;
      toast.dismiss();
      if (retval.success) {
        toast.success("Item deleted Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Item deletion Failed " + retval.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return response;
    } catch (error) {
      return error;
    }
  }
);

// SUBSCRIPTION FREQUENCIES
export const getSubscriptionFrequencies = createAsyncThunk(
  "settings/getSubscriptionFrequencies",
  async (data) => {
    try {
      const response = getSubscriptionFrequenciesApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const updateSubscriptionFrequencyStatus = createAsyncThunk(
  "settings/updateSubscriptionFrequencyStatus",
  async ({ frequency, status }) => {
    try {
      toast.dismiss();
      toast.loading("Updating frequency status...", {
        position: "top-center",
      });
      const response = updateSubscriptionFrequencyStatusApi(frequency, {
        sfr_frequency: frequency,
        sfr_status: status,
      });
      const retval = await response;
      toast.dismiss();
      if (retval.success) {
        toast.success("Frequency status updated successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Frequency status update failed: " + retval.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return retval;
    } catch (error) {
      toast.dismiss();
      toast.error("Frequency status update failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);
